import { render, staticRenderFns } from "./NoticeSystem.vue?vue&type=template&id=6f5d75de&scoped=true&"
import script from "./NoticeSystem.vue?vue&type=script&lang=js&"
export * from "./NoticeSystem.vue?vue&type=script&lang=js&"
import style0 from "./NoticeSystem.vue?vue&type=style&index=0&id=6f5d75de&scoped=true&lang=css&"
import style1 from "./NoticeSystem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5d75de",
  null
  
)

export default component.exports